import { FC, useCallback, useContext, useMemo, useState } from "react";
import { ProvidersEnum } from "@finbackoffice/fe-core";
import { useRouter } from "next/router";
import { TranslationScopes } from "@finbackoffice/enums";
import classNames from "classnames";
import Button from "components/base/button/Button";
import { CasinoToolsContext } from "contexts";
import { Svg } from "components/base/svg/Svg";
import Translate from "components/base/translate/Translate";
import styles from "./casino-providers-list.module.sass";

const CasinoProvidersList: FC = () => {
    const router = useRouter();
    const { providerOptions, openProviderPanel, setOpenProviderPanel } =
        useContext(CasinoToolsContext);
    // const providersSectionRef = useRef<HTMLElement>(null);
    const [height, setHeight] = useState(0);

    const providersSectionRef = useCallback((node: any) => {
        if (!node) return;
        const resizeObserver = new ResizeObserver(() => {
            setHeight(node.clientHeight);
        });
        resizeObserver.observe(node);
    }, []);

    const handleProviderClick = useCallback(
        (val: ProvidersEnum | "All") => {
            if (router.query.provider !== val) {
                const query = { ...router.query };
                if (val === "All") {
                    delete query.provider;
                } else {
                    query.provider = val;
                }
                router.push(
                    {
                        query,
                    },
                    undefined,
                    { shallow: true },
                );
            }
        },
        [router],
    );

    /* useEffect(() => {
        console.log(providersSectionRef.current?.clientHeight);
    }, [providerOptions]); */

    const allTotalGames = useMemo(
        () => providerOptions.reduce((acc, value) => acc + value.total_games, 0),
        [providerOptions],
    );

    return (
        <div className={styles.container}>
            <span
                className={classNames(styles.providerBtn, { [styles.opened]: openProviderPanel })}
                onClick={() => {
                    setOpenProviderPanel(!openProviderPanel);
                }}>
                <Svg src="/common/desktop/casino/arrow.svg" wrapper="span" className="svg-icon" />
                {openProviderPanel ? "Hide" : "Show"}{" "}
                <Translate tid="casino_provider" namespace={TranslationScopes.Casino} />
                <Svg src="/common/desktop/casino/arrow.svg" wrapper="span" className="svg-icon" />
            </span>
            <section
                style={{
                    marginTop: openProviderPanel ? 0 : (height ?? 0) * -1 - 22,
                    // height,
                }}
                className={styles.providers}
                ref={providersSectionRef}>
                <Button
                    type="button"
                    onClick={() => handleProviderClick("All")}
                    className={classNames(!router.query.provider && styles.active)}>
                    All
                    <i className={styles.gamesCount}>{allTotalGames}</i>
                </Button>
                {providerOptions.map((item) => (
                    <Button
                        key={item.category}
                        type="button"
                        onClick={() => handleProviderClick(item.category as ProvidersEnum)}
                        className={classNames(
                            router.query.provider === item.category && styles.active,
                        )}>
                        <Svg
                            src={`/common/casino/compact/providers/${item.category
                                .replaceAll(" ", "")
                                .toLowerCase()}.svg`}
                            wrapper="span"
                            className="svg-icon"
                        />
                        <i className={styles.gamesCount}>{item.total_games}</i>
                    </Button>
                ))}
            </section>
        </div>
    );
};

export default CasinoProvidersList;
